"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ActivitiesClubsMemberships = ActivitiesClubsMemberships;
exports.Hotel = Hotel;
exports.MoviesShowsEntertainment = MoviesShowsEntertainment;
exports.Other = Other;
exports.RoadTrips = RoadTrips;
exports.Vacation = Vacation;
var _react = _interopRequireDefault(require("react"));
var _formikMiddleware = _interopRequireDefault(require("../../middleware/formikMiddleware"));
var _TextInputForForm = require("../Wizard/TextInputForForm");
var _RetirementIncomeGapWizardCalc = require("./RetirementIncomeGapWizardCalc.config");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ActivitiesClubsMemberships(_ref) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref;
  var fieldName = 'travel_activitiesClubsMemberships';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Activities/Clubs/Memberships',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function MoviesShowsEntertainment(_ref2) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref2;
  var fieldName = 'travel_moviesShowsEntertainment';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Movies, Shows & Entertainment',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function Vacation(_ref3) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref3;
  var fieldName = 'travel_vacation';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Vacation (Flights, Cruises, Travel, etc.)',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function Hotel(_ref4) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref4;
  var fieldName = 'travel_hotelStays';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Hotel Stays',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function RoadTrips(_ref5) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref5;
  var fieldName = 'travel_roadTrips';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Road Trips',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}
function Other(_ref6) {
  var {
    errors,
    touched,
    values,
    setFieldValue
  } = _ref6;
  var fieldName = 'travel_otherTravelEntertainmentExpenses';
  var type = 'text';
  var inputMode = 'numeric';
  var maxLength = '10';
  var placeholder = '0';
  function generateOnChange() {
    return (0, _formikMiddleware.default)().digitFilterChainHandler({
      removeLeadingZeroes: true,
      currencyInput: true,
      zeroAlways: false
    }).handleChange();
  }
  function generateOnBlur() {
    return (0, _formikMiddleware.default)().tealium(_RetirementIncomeGapWizardCalc.calcName, fieldName).handleBlur();
  }
  return /*#__PURE__*/_react.default.createElement(_TextInputForForm.TextInputForForm, {
    errors: errors,
    touched: touched,
    fieldName: fieldName,
    label: 'Other',
    values: values,
    setFieldValue: setFieldValue,
    type: type,
    inputMode: inputMode,
    maxLength: maxLength,
    placeholder: placeholder,
    prepend: true,
    onChange: generateOnChange(),
    onBlur: generateOnBlur(),
    id: _RetirementIncomeGapWizardCalc.idPrefix + fieldName
  });
}